import {
  Button,
  ButtonVariants,
  FormControlSizes,
  useCallbackRef,
  useMarketAccountsContext,
  useMarketsContext,
} from '@talos/kyoko';
import { useAppStateDispatch } from '../../../../../providers/AppStateProvider';
import { useSubAccounts } from '../../../../../providers/SubAccountsContext';
import { useTradingSettings } from '../../../../../providers/TradingSettingsContext';
import { rfqSliceActions } from '../../../../OMS/NewRFQ/RFQSlice';
import { openView } from '../../../../OMS/OMSSlice';
import { OMSView } from '../../../../OMS/OMSView';
import type { PriceGridActionClickHandler, PriceGridActionClickParams, PriceGridPrimingContext } from '../common/types';
import { getPrimeRFQParams } from './getPrimeRFQParams';

export interface PriceGridRFQActionButtonProps extends PriceGridActionClickParams {
  onRFQClick: PriceGridActionClickHandler;
}

export function PriceGridRFQActionButton({
  data,
  symbol,
  orderQty,
  marketSelectorValue,
  onRFQClick,
}: PriceGridRFQActionButtonProps) {
  return (
    <Button
      size={FormControlSizes.Small}
      variant={ButtonVariants.Default}
      onClick={event => {
        event.stopPropagation();
        onRFQClick({ data, symbol, orderQty, marketSelectorValue });
      }}
      data-testid={`price-grid-rfq-button-${symbol}`}
    >
      RFQ
    </Button>
  );
}

export function useRFQAction({ subAccount }: PriceGridPrimingContext = {}): PriceGridActionClickHandler {
  const dispatch = useAppStateDispatch();
  const { enableDefaultMarketCardSubAccount } = useTradingSettings();
  const { subAccountsByName } = useSubAccounts();
  const { marketsByName } = useMarketsContext();
  const { marketAccountsByName } = useMarketAccountsContext();
  const resolvedSubAccount =
    enableDefaultMarketCardSubAccount && subAccount && subAccountsByName.has(subAccount) ? subAccount : undefined;

  return useCallbackRef<PriceGridActionClickHandler>(({ symbol, orderQty, marketSelectorValue }) => {
    dispatch(openView(OMSView.RFQForm));
    dispatch(
      rfqSliceActions.primeNewRFQForm(
        getPrimeRFQParams({
          symbol,
          orderQty,
          subAccount: resolvedSubAccount,
          marketSelectorValue,
          marketsByName,
          marketAccountsByName,
        })
      )
    );
  });
}
